var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3626 2.40527C13.558 2.40527 14.7046 2.8796 15.5506 3.72413C16.3966 4.56866 16.8729 5.71439 16.875 6.90977C16.875 9.33524 15.9851 10.4929 12.0082 13.635L9.9657 15.2204C9.39742 15.6615 8.60258 15.6615 8.0343 15.2204L5.99175 13.635C2.01488 10.4929 1.125 9.33524 1.125 6.90977C1.12709 5.71439 1.60342 4.56866 2.44942 3.72413C3.29543 2.8796 4.44198 2.40527 5.63737 2.40527C6.85677 2.41106 8.02605 2.8912 8.89762 3.74402L9 3.84061L9.10238 3.74402C9.97395 2.8912 11.1432 2.41106 12.3626 2.40527ZM8.56905 5.03657L8.59162 5.05814C8.82 5.27669 9.17992 5.27669 9.4083 5.05814L9.43103 5.03644C10.0238 4.46902 10.6387 3.8805 11.4285 3.66077C11.731 3.57658 12.0459 3.53203 12.3652 3.53027C13.2617 3.53098 14.1213 3.88697 14.7557 4.52033C15.3905 5.15402 15.7481 6.01361 15.75 6.91053C15.7499 7.93619 15.5754 8.58569 15.0244 9.34019C14.4086 10.1834 13.3129 11.1703 11.3146 12.7493L9.27592 14.3317C9.11355 14.4577 8.88645 14.4577 8.72408 14.3317L6.68545 12.7493C4.68711 11.1703 3.59137 10.1834 2.97558 9.34019C2.42464 8.58577 2.25011 7.93634 2.25 6.9108C2.25181 6.01378 2.60936 5.15408 3.24422 4.52033C3.87869 3.88697 4.73831 3.53098 5.63471 3.53027C5.95387 3.53203 6.26849 3.57652 6.57089 3.66059C7.36097 3.88026 7.97602 4.46899 8.56905 5.03657Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFavorite);
export default __webpack_public_path__ + "static/media/icon_favorite.6a88c6a20df03c92dce1f4573dc0c779.svg";
export { ForwardRef as ReactComponent };